import { render, staticRenderFns } from "./Donation.vue?vue&type=template&id=72953f34&"
import script from "./Donation.vue?vue&type=script&lang=ts&"
export * from "./Donation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports